import React from 'react';
import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react';
import styled from '@emotion/styled';

export interface AutoGridProps
  extends Omit<
    SimpleGridProps,
    'columns' | 'templateColumns' | 'minChildWidth'
  > {
  childWidth: string;
}

const StyledSimpleGrid = styled(SimpleGrid)`
  & > * {
    align-self: stretch;
  }
`;

const AutoGrid: React.FC<AutoGridProps> = ({
  children,
  childWidth,
  ...props
}) => {
  return (
    <StyledSimpleGrid
      templateColumns={`repeat(auto-fill, minmax(min(${childWidth}, 100%), 1fr))`}
      {...props}
    >
      {children}
    </StyledSimpleGrid>
  );
};

AutoGrid.defaultProps = {};

export default AutoGrid;
